import React from 'react'
import { Card, message } from 'antd'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { changeFormFields, sendLoginRequest, sendMfaVerification, loginWithPasskey, resetMfa } from '../../actions/login'
import Form from './Form'
import MfaForm from './MfaForm'
import AppFooter from '../../components/AppFooter'
import logoImage from '../../assets/logo-full.png'
import backgroundImage from '../../assets/background.jpg'
import './index.less'

class Login extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.isLoginLoading && nextProps.isLoginSuccess) {
      message.success('You have successfully logged in.')
    } else if (this.props.isLoginLoading && nextProps.loginError) {
      message.error(nextProps.loginError)
    }
  }

  render() {
    const { isLoggedIn, mfaRequired } = this.props
    if (isLoggedIn) {
      return <Redirect to={{ pathname: '/admin' }} />
    }
    return (
      <div
        className='login-page'
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        <Card className='login-form'>
          <div className='header'>
            <img src={logoImage} width='100%' alt='Temple Chambers' />
            <br />
            <br />
            <p>Administration Portal</p>
          </div>
          {mfaRequired ? (
            <MfaForm
              onSubmit={this.props.handleMfaSubmit}
              onCancel={this.props.handleMfaReset}
              isLoading={this.props.isLoginLoading}
            />
          ) : (
            <Form
              onSubmit={this.props.handleFormOnSubmit}
              onFieldsChange={this.props.handleFormOnFieldsChange}
              onPasskeyLogin={this.props.handlePasskeyLogin}
              formFieldValues={this.props.formFieldValues}
              isLoading={this.props.isLoginLoading}
            />
          )}
        </Card>
        <AppFooter />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    formFieldValues,
    isLoginLoading,
    isLoginSuccess,
    loginError,
    mfaRequired,
  } = state.login
  const isLoggedIn = !!state.app.accessToken
  return {
    formFieldValues,
    isLoginLoading,
    isLoggedIn,
    isLoginSuccess,
    loginError,
    mfaRequired,
  }
}

const mapDispatchToProps = dispatch => ({
  handleFormOnSubmit: formValues => dispatch(sendLoginRequest(formValues)),
  handleFormOnFieldsChange: formFieldsChange => dispatch(changeFormFields(formFieldsChange)),
  handleMfaSubmit: code => dispatch(sendMfaVerification(code)),
  handleMfaReset: () => dispatch(resetMfa()),
  handlePasskeyLogin: email => dispatch(loginWithPasskey(email)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
